"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.from");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

var _storage = _interopRequireDefault(require("../../utils/storage"));

var _constants = require("../../constants");

var _rootLocalStore = _interopRequireDefault(require("../../utils/rootLocalStore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var merge = function merge(next) {
  return function (params) {
    // 初始化时上报缓存的异常数据
    var _ref = params || {},
        isSaveFailed = _ref.isSaveFailed,
        data = _ref.data,
        others = _objectWithoutProperties(_ref, ["isSaveFailed", "data"]);

    var fixOthers = params ? others : _storage.default.getItem(_constants.SENTRY_CONFIG); // fixOthers可能为空数组

    if (fixOthers && Object.prototype.toString.call(fixOthers) === '[object Object]') {
      _rootLocalStore.default.getAll().then(function (all) {
        var mergedData = isSaveFailed ? _toConsumableArray(all).concat([data]) : all;

        if (mergedData && mergedData.length) {
          next(Object.assign({}, fixOthers, {
            data: mergedData
          }));
        }
      });
    }
  };
};

var _default = merge;
exports.default = _default;